import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { onUnmounted } from 'vue';
import zhCn from 'element-plus/es/locale/lang/zh-cn';
import { useUpdateDetector } from '@/composables/useUpdateDetector';
export default {
  __name: 'App',
  setup(__props) {
    const {
      cleanup
    } = useUpdateDetector();
    onUnmounted(cleanup);
    return (_ctx, _cache) => {
      const _component_router_view = _resolveComponent("router-view");
      const _component_el_config_provider = _resolveComponent("el-config-provider");
      return _openBlock(), _createBlock(_component_el_config_provider, {
        locale: _unref(zhCn)
      }, {
        default: _withCtx(() => [_createVNode(_component_router_view)]),
        _: 1
      }, 8, ["locale"]);
    };
  }
};